module.exports = __webpack_public_path__ + "img/38.1ca93f06.svg";